import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Container, Box } from '@mui/material';

import { APPBAR_MAX_HEIGHT } from 'config/constants';

function Body({ children }: React.PropsWithChildren<{}>) {
	const { classes } = useStyles();

	return (
		<Container component="main" maxWidth={false} className={classes.container}>
			<Box>{children}</Box>
		</Container>
	);
}

const useStyles = makeStyles()((theme) => ({
	container: {
		paddingTop: `${APPBAR_MAX_HEIGHT + theme.spacing(2)}px`,
	},
}));

export default Body;
